import React, { useEffect, useState } from 'react'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

import { Paragraph } from '../../../pages/WebsitePagePage/WebsitePageHoursEditForm.styles.js'
import './ServicesDetails.css'

const ServiceDetails = (props) => {
  const [serviceOverview, setServiceOverview] = useState('')
  const [serviceDetails, setServiceDetails] = useState('')
  const [localCopy, setLocalCopy] = useState('')

  function fixListStructure(richTextJson) {
    if (!richTextJson?.content) return richTextJson;
    const fixNode = (node) => {
      if (node.nodeType === 'unordered-list' || node.nodeType === 'ordered-list') {
        return {
          ...node,
          content: node.content.map(fixNode),
        };
      }
      if (node.nodeType === 'list-item') {
        const fixedContent = [];
        node.content.forEach((child) => {
          if (child.nodeType === 'paragraph') {
            fixedContent.push(...child.content.map(fixNode));
          } else if (child.nodeType === 'unordered-list' || child.nodeType === 'ordered-list') {
            fixedContent.push(fixNode(child));
          } else {
            fixedContent.push(fixNode(child));
          }
        });
        return {
          ...node,
          content: fixedContent,
        };
      }
      if (Array.isArray(node.content)) {
        return {
          ...node,
          content: node.content.map(fixNode),
        };
      }
      return node;
    };
    return {
      ...richTextJson,
      content: richTextJson.content.map(fixNode),
    };
  }

  useEffect(() => {
    setServiceOverview(
      props.data[props.group].services[props.service].serviceOverview
        ? props.data[props.group].services[props.service].serviceOverview.json
        : ''
    )

    setServiceDetails(
      props.data[props.group].services[props.service].serviceDetails
        ? props.data[props.group].services[props.service].serviceDetails.json
        : ''
    )

    const rawJson = props.data[props.group].services[props.service].localCopy?.json;
    const fixedJson = fixListStructure(rawJson);
    setLocalCopy(
      fixedJson
        ? documentToHtmlString(fixedJson)
        : ''
    );
  }, [])

  return (
    <div className="services-form">
      <div>
        <div id="service-title" style={{ marginBottom: '20px' }}>
          <h2 className="sidebar-header">{`Edit ${
            props.data[props.group].services[props.service].internalName ||
            props.data[props.group].services[props.service].name
          } details`}</h2>
          <Paragraph>
            Optional. Add any additional information for this service you would
            like to appear at the bottom of this detail page.
          </Paragraph>
        </div>

        <div id="service-local" style={{ marginBottom: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h6 className="text-lg font-semibold mb-3 mt-6">
              Location Specific Information
            </h6>
          </div>
          <div>
            <CKEditor
              editor={ClassicEditor}
              config={{
                toolbar: ['heading', 'bold', 'italic', 'link', 'bulletedList', 'numberedList'],
                link: {
                  defaultProtocol: 'https://',
                  decorators: {
                    openInNewTabExternal: {
                      mode: 'automatic',
                      callback: (url) => {
                        return /^(http|https):\/\//.test(url);
                      },
                      attributes: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                      }
                    },
                    openInSameTabInternal: {
                      mode: 'automatic',
                      callback: (url) => {
                        return url.startsWith('/');
                      },
                      attributes: {
                        target: '_self'
                      }
                    }
                  }
                }
              }}
              data={localCopy}
              onChange={(event, editor) => {
                const data = editor.getData()
                props.updateLocalCopy(data)
              }}
              className="border-0 hello"
            />
          </div>
        </div>

        <div
          id="service-overview"
          style={{
            marginBottom: '20px',
            color: 'rgba(144,144,144,1)',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h6 className="text-lg font-semibold mb-3 mt-6">Overview</h6>
          </div>
          <div
            className="text-container"
            style={{ borderColor: 'rgba(144,144,144,1)' }}
          >
            {documentToReactComponents(serviceOverview)}
          </div>
        </div>
      </div>
      <div
        id="service-details"
        style={{ marginBottom: '20px', color: 'rgba(144,144,144,1)' }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h6 className="text-lg font-semibold mb-3 mt-6">Details</h6>
        </div>
        <div
          className="text-container"
          style={{ borderColor: 'rgba(144,144,144,1)' }}
        >
          {documentToReactComponents(serviceDetails)}
        </div>
      </div>
    </div>
  )
}

export default ServiceDetails
